import { AutogenLayoutDispatchSelectTrailer } from "./autogen/AutogenLayoutDispatchSelectTrailer";
import { ChangeEvent, SelectionMode, SelectionType, TableSelectionEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { CommonTooltips } from "@mcleod/common";

export class DispatchSelectTrailer extends AutogenLayoutDispatchSelectTrailer {

    private _selectedTrailer: string = null;
    private trailerSelectListeners: Array<(newValue: string) => void> = [];

    override onLoad(): void | Promise<void> {
        this.layoutTrailerPoolCurrent.hideControls();
        this.layoutTrailerPoolCurrent.tableTrailers.selectionMode = SelectionMode.SINGLE;
        this.layoutTrailerPoolCurrent.tableTrailers.addSelectionListener(
            (event: TableSelectionEvent) => this.tableTrailersOnRowSelect(event)
        );
        this.layoutTrailerPoolPrevious.hideControls();
        this.layoutTrailerPoolPrevious.tableTrailers.selectionMode = SelectionMode.SINGLE;
        this.layoutTrailerPoolPrevious.tableTrailers.addSelectionListener(
            (event: TableSelectionEvent) => this.tableTrailersOnRowSelect(event)
        );
    }

    public initialize(modelRow: ModelRow) {
        this.panelControls.displayData(modelRow, null, 0);
        this.layoutTrailerPoolCurrent.searchTrailerPool({
            location_id: modelRow.getString("curr_location_id"),
            include_in_prog: false,
            include_preloaded_orders: false
        });
        this.layoutTrailerPoolPrevious.searchTrailerPool({
            location_id: modelRow.getString("prev_location_id"),
            include_in_prog: false,
            include_preloaded_orders: false
        });
        CommonTooltips.setTooltipContentLayout(
            this.panelCurrentLocation,
            modelRow?.get("curr_location_id"),
            "lme/dispatch/LocationQuickInfo"
        );
        CommonTooltips.setTooltipContentLayout(
            this.panelPreviousLocation,
            modelRow?.get("prev_location_id"),
            "lme/dispatch/LocationQuickInfo"
        );
    }

    private switchLocationOnChange(event: ChangeEvent) {
        const isPrevious: boolean = this.switchLocation.checked;
        this.selectedTrailer = null;

        if (isPrevious) {
            this.layoutTrailerPoolCurrent.tableTrailers.selectRow(null, SelectionType.SINGLE, null);
        } else {
            this.layoutTrailerPoolPrevious.tableTrailers.selectRow(null, SelectionType.SINGLE, null);
        }
        this.layoutTrailerPoolCurrent.visible = !isPrevious;
        this.layoutTrailerPoolPrevious.visible = isPrevious;
        this.panelCurrentLocation.visible = !isPrevious;
        this.panelPreviousLocation.visible = isPrevious;
    }

    private tableTrailersOnRowSelect(event: TableSelectionEvent) {
        if (event && event.newRow != undefined) {
            this.selectedTrailer = event.newRow.data.getString("trailer_id", null);
            return;
        }
        this.selectedTrailer = null;
    }

    get selectedTrailer(): string {
        return this._selectedTrailer;
    }

    set selectedTrailer(newValue: string) {
        this._selectedTrailer = newValue;
        this.trailerSelectListeners.forEach(listener => listener(newValue));
    }

    public addTrailerSelectListener(listener: (newValue: string) => void) {
        this.trailerSelectListeners.push(listener);
    }

}
